module.exports = __webpack_public_path__ + "img/create-the-future.2fa89bcb.webp";